import { render } from "./EventBlock.vue?vue&type=template&id=9aef205c"
import script from "./EventBlock.vue?vue&type=script&lang=js"
export * from "./EventBlock.vue?vue&type=script&lang=js"

import "./EventBlock.vue?vue&type=style&index=0&id=9aef205c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__